import { type ReactNode } from 'react';

/**
 * カード印刷の右ペイン設定セクションを折りたためる共通ラッパー (2026-06-13)。
 *
 * 操作盤が縦に長くなりすぎて操作性が悪い問題への対処。native `<details>`/`<summary>` を使い
 * 状態管理不要・a11y (キーボード開閉) 対応。`<summary>` は display:flex にしない
 * (ネイティブの開閉三角マーカーが消えるため)。
 */
export interface CollapsibleSectionProps {
  title: string;
  children: ReactNode;
  /** 既定で開くか。false で初期折りたたみ (操作盤を短く保つ)。既定 true。 */
  defaultOpen?: boolean;
  /** data-testid (任意)。 */
  testId?: string;
}

export function CollapsibleSection({
  title,
  children,
  defaultOpen = true,
  testId,
}: CollapsibleSectionProps): JSX.Element {
  return (
    <details
      open={defaultOpen}
      data-testid={testId}
      className="border border-slate-200 rounded bg-white"
    >
      <summary className="px-2 py-1.5 cursor-pointer select-none text-sm font-bold text-slate-800 hover:bg-slate-50 rounded marker:text-slate-400">
        {title}
      </summary>
      <div className="px-2 pb-2 pt-1 border-t border-slate-100">{children}</div>
    </details>
  );
}
